import i18n from 'i18next';
import { useEffect, useState } from 'react';
import { getTimeZonesEffect } from '../../../redux/shipment/ShipmentEffects';
import FormSelectBox from '../Inputs/FormSelectBox';

const TimeZoneSelectorTMS = ({
  placeholder = i18n.t('translation:default.fields.timeZone.placeholder'),
  label = i18n.t('translation:default.fields.timeZone.label'),
  rules = [],
  name,
  editMode,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getStatusList();
  }, []);

  const getStatusList = async () => {
    try {
      setLoading(true);
      const { data } = await getTimeZonesEffect();
      const options = data.map((row) => ({
        label: row.text,
        value: row.value,
      }));
      setOptions(options);
      setLoading(false);
    } catch {
      setOptions([]);
      setLoading(false);
    }
  };
  return (
    <FormSelectBox
      loading={loading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin="mb-0"
      rules={rules}
      name={name}
      editMode={editMode}
    />
  );
};

export default TimeZoneSelectorTMS;
